module.exports = __webpack_public_path__ + "img/adminSystem.9c923ba2.png";